import type { Id } from '@e-socna/data-layer';

import { printSettingsForm2ApiMapper } from './print-settings.form2api.mapper';

type Printable = Readonly<{
  _id: Id;
  printing: Readonly<{
    printSettings: Parameters<typeof printSettingsForm2ApiMapper>[0];
  }>;
}>;

export const printSettingsUpdateForm2ApiMapper = (printable: Printable) => ({
  printableId: printable._id,
  printSettings: printSettingsForm2ApiMapper(printable.printing.printSettings),
});
